import type { ResponseReadAll } from "epsm-api-types";
import { SCREENER_COLUMNS, type ScreenerColumn } from "epsm-api-types/models";
import type { IReadAllParams } from "@/services/RequestParams";

export class ScreenerColumnService {
	private constructor() {}

	private static instance: ScreenerColumnService;

	static create() {
		if (!ScreenerColumnService.instance) {
			ScreenerColumnService.instance = new ScreenerColumnService();
		}
		return ScreenerColumnService.instance;
	}

	async getData(
		_params: Readonly<IReadAllParams> = {},
	): Promise<ResponseReadAll<ScreenerColumn>> {
		return await Promise.resolve({ data: SCREENER_COLUMNS });
	}
}
